module.exports = __webpack_public_path__ + "static/img/6188_phase_function_Paper_Points.0ceadd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6188_phase_function_Paper_Points.png
// module id = HPTw
// module chunks = 0